import React, { useState, useEffect, useContext } from 'react';
import { Button, Input, Label, Dimmer, Loader, Checkbox } from 'semantic-ui-react';
import './style.less';
import queryString from 'query-string';
import { getResidentInvitationByToken } from '../../../services/messageRecipients';
import RedirectContext from '../../../contexts/RedirectContext';

import { getMyQuota } from '../../../services/quotas';

import { toast } from 'react-toastify';

const AlexaUserInvitationAccept = (props) => {
    const [invitation, setInvitation] = useState(null);
    const [loading, setLoading] = useState(true);
    const toggleRedirect = useContext(RedirectContext);

    const [isSSODone, setIsSSODone] = useState(false);
    const [shouldPay, setShouldPay] = useState(false);
    const [tok, setTok] = useState('');
    useEffect(() => {
        const { token } = props.match.params;
        console.log(token, 'dd');
        if (token) {
            setTok(token);
            setLoading(true);
            getResidentInvitationByToken(token).then(async (result) => {
                setInvitation(result);
                console.log(result, 'dds');
                const { invitationStatus } = result;

                if (['sso_done', 'done'].includes(invitationStatus)) {
                    setIsSSODone(true);
                } else {
                    setIsSSODone(false);
                }

                if (result.invitedUserPays && result.paymentManagerId) {
                    // Here call to get the quota and compare
                    const response = await getMyQuota(result.paymentManagerId);
                    if (response.residentCount && response.totalQuota >= response.residentCount) {
                        setShouldPay(false);
                        toggleRedirect(`/public/checkout-success`);
                    } else {
                        setShouldPay(true);
                    }
                    console.log(response);
                } else if (!result.invitedUserPays && ['sso_done', 'done'].includes(invitationStatus)) {
                    toggleRedirect(`/public/checkout-success`);
                } else {
                    setShouldPay(!!result.invitedUserPays);
                }

                setLoading(false);
            });
        }
    }, [props.match.params]);

    const uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };

    const gotoPayment = () => {
        toggleRedirect(`/public/checkout/${invitation.paymentManagerId}?invitationId=${tok}`);
    };

    const handleLink = () => {
        // generate uuid
        // generate what to be saved
        // and redirect
        const state = uuidv4();
        const invitationParam = {
            invitationToken: invitation.inviteToken,
            isAlexaUserInvite: true,
        };

        localStorage.setItem(state, JSON.stringify(invitationParam));
        const hostname = window.location.hostname;
        // const hostname = 'development.speak2family.com';
        const redirect_uri = `https://${hostname}/sso-redirect`;
        const url = `https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.cec7f0739d0c48929547c0965562f5b3&scope=alexa::skills:account_linking&response_type=code&redirect_uri=${redirect_uri}&state=${btoa(
            state,
        )}`;

        window.location.href = url;
    };

    const handleClick = () => {
        if (isSSODone) {
            if (invitation.invitedUserPays) {
                if (shouldPay) {
                    // Send to pay
                    gotoPayment();
                } else {
                    // Send to done
                    toggleRedirect(`/public/checkout-success`);
                }
            } else {
                // Send to done
                toggleRedirect(`/public/checkout-success`);
            }
        } else {
            // Send to sso
            handleLink();
        }
    };

    return (
        <div className="alexa-invite-link-sso">
            {loading ? (
                <Dimmer className="pt-80" active={loading} inverted>
                    <Loader active={loading} />
                </Dimmer>
            ) : invitation ? (
                <div className="alexa-user-payment-page relative-list">
                    <p>
                        <img
                            className="speak2-logo"
                            src="https://f.hubspotusercontent40.net/hubfs/8458943/Mark-Only@0.5x.jpg"
                            alt="Speak2 Family"
                            height="100"
                        />
                    </p>
                    <p className="blue-text center-align">
                        <strong className="one-four-em">CONNECT TO SPEAK2 FAMILY HERE!</strong>
                    </p>
                    <p className="blue-text">
                        Hi {invitation ? invitation.alexaUser.firstName : ''}, this is where you connect your Amazon
                        account to Speak2 Family.
                        <br />
                        {invitation.message ? (
                            <div>
                                <div className="message-title">
                                    Here is the message you received from{' '}
                                    {invitation && invitation.managerName ? invitation.managerName : ''}
                                </div>
                                <div className="message">{invitation.message}</div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <br /> <br />
                        When you click the below button, you will be brought to Amazon.com to sign in and link your
                        Amazon account with Speak2. You will then be brought back to Speak2.
                    </p>
                    <p className="center-align">
                        <button
                            className="link-button"
                            onClick={() => {
                                handleClick();
                            }}
                        >
                            Click here to link your Amazon Account and Alexa with {invitation && invitation.managerName}
                        </button>
                    </p>
                    {shouldPay ? (
                        <p className="blue-text">
                            You will be prompted to enter your credit card after you connect with Amazon, so please have
                            your card ready.&nbsp;&nbsp;
                        </p>
                    ) : (
                        <p></p>
                    )}
                    <hr className="bar" align="center" />
                    <div className="social-container">
                        <a
                            title="Speak2 Family"
                            href="https://www.facebook.com/speak2family/"
                            target="_blank"
                            rel="noopener"
                        >
                            <img
                                src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/facebook_circle_color.png"
                                alt="Facebook"
                                width="40"
                                height="40"
                            />
                        </a>
                        <a
                            title="Speak2 Family"
                            href="https://www.linkedin.com/company/71667950/"
                            target="_blank"
                            rel="noopener"
                        >
                            <img
                                src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/linkedin_circle_color.png"
                                alt="LinkedIn"
                                width="40"
                                height="40"
                            />
                        </a>
                        <a
                            title="Speak2 Family"
                            href="http://instagram.com/speak2family"
                            target="_blank"
                            rel="noopener"
                        >
                            <img
                                src="https://email.speak2family.com/hs/hsstatic/TemplateAssets/static-1.24/img/hs_default_template_images/modules/Follow+Me+-+Email/instagram_circle_color.png"
                                alt="Instagram"
                                width="40"
                                height="40"
                            />
                        </a>
                    </div>
                </div>
            ) : (
                <div>Invalid invitation</div>
            )}
        </div>
    );
};

export default AlexaUserInvitationAccept;
